import { useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, BottomBarActionButtonV2, DialogV2 } from '@/components/custom/erp';
import { CustomerGroupFormValues, customerGroupSchema } from '../schemas';
import { CustomerGroupType, Group } from '@/types/schemas';
import { BasicInfoTab } from './BasicInfoTab';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: CustomerGroupFormValues) => void;
  formMode: 'add' | 'edit' | 'view';
  initialData?: Group;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  activeGroup?: CustomerGroupType;
  groups?: Group[];
  isCopyMode?: boolean;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick,
  activeGroup,
  groups = [],
  isCopyMode = false
}: FormDialogProps) => {
  const [showDuplicateCodeDialog, setShowDuplicateCodeDialog] = useState(false);

  const handleSubmit = async (data: CustomerGroupFormValues) => {
    try {
      const existingGroups = Array.isArray(groups) ? groups : [];

      if (formMode === 'add') {
        const isDuplicate = existingGroups.some((group: Group) => group.ma_nhom === data.ma_nhom);

        if (isDuplicate) {
          setShowDuplicateCodeDialog(true);
          return;
        }
      } else if (formMode === 'edit' && initialData) {
        const isDuplicate = existingGroups.some(
          (group: Group) => group.ma_nhom === data.ma_nhom && group.uuid !== initialData.uuid
        );

        if (isDuplicate) {
          setShowDuplicateCodeDialog(true);
          return;
        }
      }

      onSubmit(data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={`${formMode === 'add' ? 'Thêm mới' : formMode === 'edit' ? 'Sửa' : 'Danh mục phân nhóm'}`}
        maxWidth='xl'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={formMode}
          hasAritoActionBar={false}
          schema={customerGroupSchema}
          onSubmit={handleSubmit}
          initialData={
            (formMode === 'add' && initialData && isCopyMode
              ? {
                  ...initialData,
                  uuid: undefined,
                  ma_nhom: '',
                  ten_phan_nhom: initialData.ten_phan_nhom,
                  ten2: initialData.ten2 || '',
                  trang_thai: initialData.trang_thai || '1'
                }
              : formMode === 'add' && !isCopyMode
                ? undefined
                : initialData) as CustomerGroupFormValues | undefined
          }
          className='w-[800px]'
          headerFields={<BasicInfoTab formMode={formMode} />}
          bottomBar={
            <BottomActionBarV2
              mode={formMode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>

      {/* Dialog hiển thị thông báo lỗi khi mã nhóm đã tồn tại */}
      <DialogV2
        open={showDuplicateCodeDialog}
        onClose={() => setShowDuplicateCodeDialog(false)}
        title='Cảnh báo'
        maxWidth='sm'
        disableBackdropClose={false}
        disableEscapeKeyDown={false}
        titleIcon={<AritoIcon icon={260} />}
      >
        <div className='p-4'>
          <p className='mb-4 text-center'>Mã nhóm đã tồn tại trong danh mục nhóm</p>
          <div className='flex justify-end'>
            <BottomBarActionButtonV2 icon={884} title='Đồng ý' onClick={() => setShowDuplicateCodeDialog(false)} />
          </div>
        </div>
      </DialogV2>
    </>
  );
};

export default FormDialog;
